import React, { useMemo } from 'react';

const Sidebar = ({ groups, onGroupClick, onResetClick, activeGroupId, selectedProduct, onToggleView, viewMode, allCircles = [] }) => {
  const circleIdToLabelMap = useMemo(() => {
    return new Map(allCircles.map(circle => [circle.id, circle.label]));
  }, [allCircles]);

  return (
    <div className="sidebar">
      {selectedProduct && (
        <div className="selected-product-info">
          <h3>{selectedProduct.label}</h3>
          {selectedProduct.image && <div className="product-image-container"><img src={selectedProduct.image} alt="presentation content" /></div>}
          <p>{selectedProduct.description}</p>
          {selectedProduct.products && selectedProduct.products.length > 0 && (
            <div className="related-products">
              <h4>Related Products</h4>
              <ul>
                {selectedProduct.products.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}

      <h2>AAA System Solutions</h2>
      <ul>
        {groups && groups.map(group => {
          const isGroupActive = group.id === activeGroupId;
          const isDiagramActiveForThisGroup = isGroupActive && viewMode === 'diagram';
          
          const primaryCircleLabels = group.circles.map(id => circleIdToLabelMap.get(id)).filter(Boolean);
          const addOnLabels = (group['add-ons'] || []).map(id => circleIdToLabelMap.get(id)).filter(Boolean);

          return (
            <li
              key={group.id}
              className={isGroupActive ? 'active' : ''}
              onClick={() => onGroupClick(group)}
            >
              <div className="group-name">{group.name}</div>
              <div className="group-description">
                <p>{group.description}</p>
                <p className="group-contents-list">
                  <strong>Primary System:</strong> {primaryCircleLabels.join(', ')}
                </p>
                <p>{addOnLabels.length > 0 && (<>
                  <strong>Add-ons:</strong> {addOnLabels.join(', ')}
                  </>
                  )}
                </p>
                {isGroupActive && group.diagramImage && (
                  <div className="toggle-view-link" onClick={(e) => {
                    e.stopPropagation();
                    onToggleView(group);
                  }}>
                    {isDiagramActiveForThisGroup ? 'Toggle Ecosystem' : 'Toggle Diagram'}
                  </div>
                )}
              </div>
            </li>
          );
        })}
      </ul>
      <div className="reset-link" onClick={onResetClick}>
        Reset Selections
      </div>
    </div>
  );
};

export default Sidebar;